import gql from "graphql-tag";

export default gql`
  mutation rewardUpdateById($record: UpdateByIdrewardsInput!) {
    rewardUpdateById(record: $record) {
      record {
        _id
      }
    }
  }
`;
